import { useEffect, useState } from "react";
import "./App.css";
import ICalculatorConfigurationWithMinimumFee from "./@shared/models/ICalculatorConfigurationWithMinimumFee";
import CalculatorInputs from "./CalculatorInputs";
import localConfiguration from "./localData/sampleConfiguration.json";

interface IProps {
  printingOption: string;
  productId: number;
  isSchoolUser: boolean;
  wpNonce: string;
}

function App({ printingOption, productId, isSchoolUser, wpNonce }: IProps) {
  const [loading, setLoading] = useState(true);
  const [configuration, setConfiguration] = useState(
    {} as ICalculatorConfigurationWithMinimumFee,
  );
  const [userType, setUserType] = useState(
    isSchoolUser ? "school" : "individual",
  );

  useEffect(() => {
    fetch("/?rest_route=/copyquick/printondemand/configuration", {
      headers: { "X-WP-Nonce": wpNonce },
    })
      .then(async (r) => {
        const responseBody = await r.text();
        const responseJson = JSON.parse(responseBody);
        setConfiguration(responseJson);

        if (responseJson.roles && responseJson.roles.includes("school")) {
          setUserType("school");
        }
        setLoading(false);
      })
      .catch((e) => {
        setConfiguration(localConfiguration);
        setLoading(false);
      });
  }, [setLoading, setConfiguration, wpNonce]);

  return (
    <div className="App">
      {!loading ? (
        <CalculatorInputs
          configuration={configuration}
          printingOption={printingOption}
          productId={productId}
          userType={userType}
          wpNonce={wpNonce}
        />
      ) : (
        <p>Loading Configuration</p>
      )}
    </div>
  );
}

export default App;
